<template>
  <span>
    <div class="p-fluid formgrid grid">
      <div v-show="exibirListaEntidades" class="field col-6 md:col-6">
        <label for="entidade">Entidade</label>
        <MultiSelect
          id="entidade"
          v-model="v$.entidadesSelecionadas.$model"
          :class="{
            'p-invalid': submitted && v$.entidadesSelecionadas.$invalid,
          }"
          optionLabel="nome"
          :options="entidades"
          :filter="true"
          filterPlaceholder="Procure pelo nome da entidade"
          :emptyFilterMessage="'Nenhuma entidade encontrada'"
          placeholder="Selecione uma entidade"
          display="chip"
          @input="adicionarEntidade">
        </MultiSelect>
        <div
          v-if="submitted && v$.entidadesSelecionadas.required.$invalid"
          class="p-error">
          O campo entidade é obrigatório.
        </div>
      </div>
      <div v-show="exibirListaConsignataria" class="field col-6 md:col-6">
        <label for="consignataria">Consignatária</label>
        <MultiSelect
          id="consignataria"
          v-model="v$.consignatariasSelecionadas.$model"
          dataKey="id"
          :disabled="habilitarCampoConsignataria"
          :class="{
            'p-invalid': submitted && v$.consignatariasSelecionadas.$invalid,
          }"
          optionLabel="cnpjRazaoSocial"
          :options="concatenarCnpjRazaoSocial"
          :filter="true"
          filterPlaceholder="Procure pelo nome da consignataria"
          :emptyFilterMessage="'Nenhuma consignataria encontrada'"
          placeholder="Selecione uma consignataria"
          display="chip"
          @input="adicionarConsignataria">
        </MultiSelect>
        <div
          v-if="submitted && v$.consignatariasSelecionadas.required.$invalid"
          class="p-error">
          O campo consignataria é obrigatório.
        </div>
      </div>
      <div class="field col-6 md:col-6">
        <label for="dataEntidade">Data de Referência</label>
        <Calendar
          v-model="v$.dataReferencia.$model"
          :class="{
            'p-invalid': submitted && v$.dataReferencia.$invalid,
          }"
          view="month"
          dateFormat="mm/yy"
          @input="adicionarMesEAnoReferencia" />
        <div
          v-if="submitted && v$.dataReferencia.required.$invalid"
          class="p-error">
          O campo Data de Referência é obrigatório.
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import UseVuelidate from '@vuelidate/core'
import { required, requiredIf } from '@vuelidate/validators'
import ConsignatariaService from '@/service/ConsignatariaService.js'
import { consignatariaStore } from '@/stores/consignataria'
import EntidadeService from '@/service/EntidadeService.js'
import ServidorService from '@/service/ServidorService.js'

export default {
  name: 'LayoutFiltroReservaCartaoMargens',

  props: {
    submitted: {
      type: Boolean,
      default: false,
    },
    modulo: {
      type: String,
      required: true,
    },
  },

  setup() {
    const store = consignatariaStore()
    return { v$: UseVuelidate(), store }
  },

  data() {
    return {
      entidadesSelecionadas: [],
      entidades: [],
      entidadesIdSelecionados: [],
      consignatariasSelecionadas: [],
      consignatarias: [],
      consignatariasIdSelecionados: [],
      dataReferencia: null,
      mesReferencia: null,
      anoReferencia: null,
      exibirListaEntidades: false,
      exibirListaConsignataria: false,
      parametros: new Map(),
      cpf: null,
    }
  },

  computed: {
    habilitarCampoConsignataria() {
      return this.store.consignatariaSelecionada !== null
    },

    concatenarCnpjRazaoSocial() {
      return this.consignatarias.map((consignataria) => ({
        ...consignataria,
        cnpjRazaoSocial: consignataria.cnpj + ' | ' + consignataria.razaoSocial,
      }))
    },
  },

  validations() {
    return {
      dataReferencia: { required },
      entidadesSelecionadas: { required },
      consignatariasSelecionadas: {
        required: requiredIf(
          this.$auth.hasRoleGestao() || this.$auth.hasRoleGestaoEntidade()
            ? true
            : false,
        ),
      },
    }
  },

  created() {
    this.consignatariaService = new ConsignatariaService(this.$http)
    this.entidadeService = new EntidadeService(this.$http)
    this.servidorService = new ServidorService(this.$http)
  },

  mounted() {
    this.carregarEntidade()
    this.carregarConsignataria()
    this.carregarCpf()
  },

  methods: {
    validate() {
      this.v$.dataReferencia.$touch()
      this.v$.entidadesSelecionadas.$touch()
      this.v$.consignatariasSelecionadas.$touch()

      return !(
        this.v$.dataReferencia.$invalid ||
        this.v$.entidadesSelecionadas.$invalid ||
        this.v$.consignatariasSelecionadas.$invalid
      )
    },

    adicionarMesEAnoReferencia() {
      this.mesReferencia = (this.dataReferencia.getMonth() + 1).toString()
      this.anoReferencia = `${this.dataReferencia.getFullYear()}`
      this.parametros.set('mesReferencia', this.mesReferencia)
      this.parametros.set('anoReferencia', this.anoReferencia)
      this.$emit('parametros', this.parametros)
    },

    carregarEntidade() {
      this.carregarListaEntidades()
      this.exibirListaEntidades = true
    },

    carregarConsignataria() {
      this.carregarListaConsignatarias()
      this.exibirListaConsignataria = true
    },

    carregarCpf() {
      this.servidorService.getDadosServidor().then((res) => {
        if (this.modulo === 'servidor') {
          this.cpf = res.cpf
          this.adicionarCpf()
        }
      })
    },

    adicionarEntidade() {
      this.adicionarListaIds('entidade')
      this.parametros.set('entidadeId', this.entidadesIdSelecionados)
      this.$emit('parametros', this.parametros)
      this.entidadesIdSelecionados = []
    },

    adicionarConsignataria() {
      this.adicionarListaIds('consignataria')
      this.parametros.set('consignatariaId', this.consignatariasIdSelecionados)
      this.$emit('parametros', this.parametros)
      this.consignatariasIdSelecionados = []
    },

    adicionarCpf() {
      this.parametros.set('cpf', this.cpf)
      this.$emit('parametros', this.parametros)
    },

    adicionarListaIds(tipo) {
      if (tipo == 'status') {
        this.statusSelecionados.forEach((valor) =>
          this.statusIdSelecionados.push(valor.id.toString()),
        )
      } else if (tipo == 'entidade') {
        this.entidadesSelecionadas.forEach((valor) =>
          this.entidadesIdSelecionados.push(valor.id.toString()),
        )
      } else if (tipo == 'consignataria') {
        this.consignatariasSelecionadas.forEach((valor) =>
          this.consignatariasIdSelecionados.push(valor.id.toString()),
        )
      }
    },

    limpar() {
      if (this.modulo !== 'servidor') {
        this.cpf = null
      }
      this.entidadesSelecionadas = []
      this.entidadesIdSelecionados = []
      this.consignatariasSelecionadas = []
      this.consignatariasIdSelecionados = []
      this.dataReferencia = ''
      this.mesReferencia = ''
      this.anoReferencia = ''
    },
  },
}
</script>
